import { render, staticRenderFns } from "./PerformanceChart.vue?vue&type=template&id=40671946&scoped=true"
import script from "./PerformanceChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./PerformanceChart.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PerformanceChart.vue?vue&type=style&index=0&id=40671946&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40671946",
  null
  
)

export default component.exports